var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('pageCart',{attrs:{"title":_vm.title}},[(_vm.data)?_c('div',{staticClass:"content"},[_c('vHtml',_vm._b({},'vHtml',{markdown: _vm.data.content},false))],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }